// function calcChecker1 (firstNineDigits) {
//   let sum = null
//
//   for (let j = 0; j < 9; ++j) {
//     sum += firstNineDigits.toString().charAt(j) * (10 - j)
//   }
//
//   const lastSumChecker1 = sum % 11
//   const checker1 = (lastSumChecker1 < 2) ? 0 : 11 - lastSumChecker1
//
//   return checker1
// }
//
// function calcChecker2 (cpfWithChecker1) {
//   let sum = null
//
//   for (let k = 0; k < 10; ++k) {
//     sum += cpfWithChecker1.toString().charAt(k) * (11 - k)
//   }
//   const lastSumChecker2 = sum % 11
//   const checker2 = (lastSumChecker2 < 2) ? 0 : 11 - lastSumChecker2
//
//   return checker2
// }

// function cleaner (value) {
//   if (value) {
//     const digits = value.replace(/[^\d]/g, '')
//     return digits
//   }
// }
function getConstructor (value) {
  const string = Object.prototype.toString.call(value)
  const [ , constructor ] = /\[object (.*?)\]/.exec(string)
  return constructor
}
function is (value, constructor) {
  return constructor === getConstructor(value)
}

function validate (value) {
  if (!is(value, 'String')) {
    return false
  }

  // Novo formato alfanumérico do CNPJ: os 12 primeiros caracteres podem ser
  // letras ou dígitos e os 2 últimos (dígitos verificadores) são sempre numéricos.
  // Ex.: 00000000E08G12 -> 00.000.000/E08G-12
  const cnpj = value.toUpperCase().replace(/[^0-9A-Z]/g, '')

  if (cnpj.length !== 14) {
    return false
  }

  // Os dígitos verificadores devem ser numéricos.
  if (!/^\d{2}$/.test(cnpj.substring(12))) {
    return false
  }

  // Valor de cada caractere conforme regra da Receita Federal: código ASCII - 48
  // ('0'..'9' -> 0..9, 'A'..'Z' -> 17..42). Mantém compatibilidade com CNPJ numérico.
  const charValue = c => c.charCodeAt(0) - 48

  const getRest = dig => (((dig % 11) < 2) ? 0 : (11 - (dig % 11)))

  const calc = length => {
    let sum = 0
    let pos = length - 7

    for (let i = 0; i < length; i++) {
      sum += charValue(cnpj.charAt(i)) * pos
      pos--
      if (pos < 2) {
        pos = 9
      }
    }

    return getRest(sum)
  }

  const digito = parseInt(cnpj.charAt(12) + cnpj.charAt(13))

  return (((calc(12) * 10) + calc(13)) === digito)
}
export default validate



// WEBPACK FOOTER //
// ./src/components/i18n/cnpj.js